import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import View from './View'

export const NotificationForm: SBRMForm = forwardRef(({ formProps }, ref) => (
  <SBRM.BaseEntityForm
    {...{ ref, formProps }}
    formActions={{
      view: View,
    }}
    handlers={{}}
  />
))

NotificationForm.displayName = 'NotificationForm'

export default NotificationForm
